import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.search";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import tempTable from "@/components/rw/tempTable/index";
import tempSearch from "@/components/rw/tempSearch/index";
import tempForm from "@/components/rw/tempForm/index";
import tempChart from "@/components/rw/tempChart/index";
import { statisticsList, statisticsHandle, statisticsDelete, statisticsImport } from '../../../../api/apis';
import { export_json_to_excel } from '@/components/rw/plugin/exportCustomExcel/_export2Excel';
export default {
  name: 'memberLineApply',
  components: {
    tempTable: tempTable,
    tempSearch: tempSearch,
    tempForm: tempForm,
    tempChart: tempChart
  },
  data: function data() {
    var _this = this;

    return {
      activeNames: 'search',
      editDialogVisible: false,
      editDialogTitle: '添加',
      editIsEdit: false,
      editForm: {
        id: null,
        number: '',
        status: 0,
        remark: ''
      },
      searchModel_1000: {
        "del": false,
        "id": "id_1000",
        "operateData": [{
          "icon": "el-icon-search",
          "tag": "search",
          "title": "搜索",
          "type": "primary"
        }, {
          "icon": "el-icon-position",
          "tag": "export",
          "title": "导出",
          "type": "primary"
        }, {
          "icon": "el-icon-bottom-right",
          "tag": "import",
          "title": "批量导入",
          "type": "success"
        }, {
          "icon": "el-icon-download",
          "tag": "downloadTemplate",
          "title": "下载模板",
          "type": "warning"
        }],
        "searchData": [{
          "children": [{
            "field": [{
              "desc": "会员编号",
              "key": "number",
              "value": ""
            }],
            "operator": [],
            "placeholder": "请输入",
            "type": "input-complex"
          }],
          "id": 1,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "select": 0,
          "title": "会员编号",
          "type": 2,
          "remoteFunc": []
        }, {
          "children": [{
            "field": [],
            "title": "全部",
            "type": "button"
          }, {
            "field": [{
              "key": "status",
              "value": "0"
            }],
            "title": "禁用",
            "type": "button"
          }, {
            "field": [{
              "key": "status",
              "value": "1"
            }],
            "title": "启用",
            "type": "button"
          }],
          "id": 2,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "select": 0,
          "title": "状态",
          "type": 0,
          "remoteFunc": []
        }],
        "type": "searchTemplate"
      },
      tableModel_1001: {
        "border": true,
        "del": true,
        "headerButton": [{
          "id": "",
          "tag": "default",
          "title": "添加",
          "type": "primary"
        }, {
          "id": "",
          "tag": "mul-del",
          "title": "批量删除",
          "type": "danger"
        }],
        "id": "id_1001",
        "isGroup": false,
        "isTree": false,
        "rowButton": [{
          "id": "",
          "tag": "default",
          "title": "编辑",
          "type": "primary"
        }, {
          "id": "",
          "tag": "del",
          "title": "删除",
          "type": "danger"
        }],
        "showPagination": true,
        "showSelection": true,
        "stripe": false,
        "tableAutocompleteProps": {},
        "tableCascaderProps": {},
        "tableFileProps": {},
        "tableModel": [{
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "ID",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "60",
          "prop": "id"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "会员编号",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "120",
          "prop": "number"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "会员姓名",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "member.real_name"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "手机号",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "120",
          "prop": "member.phone"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "状态",
          "rules": [],
          "show": 1,
          "type": "select",
          "width": "80",
          "prop": "status"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "备注",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "150",
          "prop": "remark"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "操作人",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "op_uid"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "更新时间",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "150",
          "prop": "update_time"
        }],
        "tableName": "t_statistics_user",
        "tableRadioProps": {},
        "tableSelectProps": {
          "status": {
            "data": [{
              "key": 0,
              "value": "禁用"
            }, {
              "key": 1,
              "value": "启用"
            }],
            "id": 0,
            "multiple": 0,
            "relation": false,
            "relationProps": [],
            "remote": false
          }
        },
        "tableSwitchProps": {},
        "title": "折线图预审名单",
        "type": "tableTemplate"
      },
      remoteFunc: {}
    };
  },
  mounted: function mounted() {
    this.table = this.$refs.ref_1001;
    this.search = this.$refs.ref_1000;
  },
  methods: {
    reqTableData: function reqTableData(params, resolve) {
      var where = {};

      if (this.search) {
        where = this.search.parseWhere();
        params.where = where;
      }

      statisticsList(params).then(function _callee(res) {
        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resolve({
                  total: res.count,
                  data: res.rows
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        });
      });
    },
    reqAdd: function reqAdd(isEdit, params, row, resolve) {},
    reqDel: function reqDel(params, resolve) {
      var ids = params.map(function (item) {
        return item.id;
      });
      statisticsDelete({
        id: ids
      }).then(function _callee2(res) {
        return regeneratorRuntime.async(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                resolve();

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        });
      });
    },
    onClickLink: function onClickLink(prop, row) {},
    onClickRowButton: function onClickRowButton(btnIndex, row) {
      if (btnIndex === 0) {
        // 编辑
        this.editDialogTitle = '编辑';
        this.editIsEdit = true;
        this.editForm = {
          id: row.id,
          number: row.number,
          status: row.status || 0,
          remark: row.remark || ''
        };
        this.editDialogVisible = true;
      }
    },
    onClickHeaderButton: function onClickHeaderButton(btnIndex, row) {
      if (btnIndex === 0) {
        // 添加
        this.editDialogTitle = '添加';
        this.editIsEdit = false;
        this.editForm = {
          id: null,
          number: '',
          status: 0,
          remark: ''
        };
        this.editDialogVisible = true;
      }
    },
    onSummary: function onSummary(param) {},
    onSwitchChange: function onSwitchChange(val, prop, row) {},
    handleEditSubmit: function handleEditSubmit() {
      var _this2 = this;

      if (!this.editForm.number) {
        this.$message({
          message: '请输入会员编号',
          type: 'warning'
        });
        return;
      }

      var params = {
        number: this.editForm.number,
        status: this.editForm.status,
        remark: this.editForm.remark
      };

      if (this.editIsEdit) {
        params.id = this.editForm.id;
      }

      statisticsHandle(params).then(function _callee3(res) {
        return regeneratorRuntime.async(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.$message({
                  message: _this2.editIsEdit ? '编辑成功' : '添加成功',
                  type: 'success'
                });

                _this2.editDialogVisible = false;

                _this2.table.reloadData();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        });
      });
    },
    onClickSearchOperate: function onClickSearchOperate(btnIndex, btnData) {
      var _this3 = this;

      if (btnData.tag === this.$tempModel.buttonTag.search) {
        this.table.reloadData();
      } else if (btnData.tag === this.$tempModel.buttonTag.export) {
        this.table.exportExcel();
      } else if (btnData.tag === this.$tempModel.buttonTag.import) {
        var header = btnData.header;
        var results = btnData.results;
        var data = [];

        for (var i in results) {
          var item = results[i];
          var number = item['会员编号'] || item['编号'] || '';
          var remark = item['备注'] || '';

          if (number) {
            data.push({
              number: number,
              remark: remark
            });
          }
        }

        if (data.length === 0) {
          this.$alert('未检测到有效数据，请确保表中有"会员编号"列', '提示', {
            confirmButtonText: '确定'
          });
          return;
        }

        this.$confirm('确定要批量导入' + data.length + '条记录么？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          statisticsImport({
            data: data
          }).then(function _callee4(res) {
            return regeneratorRuntime.async(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _this3.$message({
                      message: '导入成功',
                      type: 'success'
                    });

                    _this3.table.reloadData();

                  case 2:
                  case "end":
                    return _context4.stop();
                }
              }
            });
          });
        }).catch(function () {});
      } else if (btnData.tag === 'downloadTemplate') {
        var _header = ['会员编号', '备注'];
        var _data = [];
        export_json_to_excel(_header, _data, '折线图预审名单导入模板');
      }
    },
    onConditionChange: function onConditionChange(tag, index) {
      this.table.reloadData();
    }
  }
};